import axios from 'axios'

const api = axios.create({
  baseURL: "https://bayut.p.rapidapi.com",
  headers: {
		"x-rapidapi-host": "bayut.p.rapidapi.com",
		"x-rapidapi-key": "f1d8790aa7msh3c7e56693a31f6fp12487bjsn2056cbefe411"
	}
})

export default api;